import { KeyValuePair } from "../../commonInterfaces";
import { EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../../core/components/editableGrid/editableGrid";
import { Helper } from "../../core/util/helper";
import React from "react";
export default class CodeRights extends React.Component<CodeRightsProps, any>{
    private gridOptions;
    constructor(props: CodeRightsProps) {
        super(props)
        this.setOptions();
    }

    private setOptions = () => {
        this.gridOptions = {
            columns: [
                {
                    type: "textBox",
                    field: "Kennung",
                    title: Helper.getTranslation("Field.Auftrag.knr"),
                    width: 250,
                    readonly: true
                },
                {
                    type: "checkbox",
                    field: "Lock",
                    title: Helper.getTranslation("WebSMS.UserSettings.Lock"),
                    "template": (item: CodeLock) => {
                        if (item.Lock == 1) {
                            return '<span class="k-icon k-i-check k-icon-md"></span>'
                        } else {
                            return '<span class="k-icon k-i-x k-icon-md"></span>'
                        }
                    }
                },
                {
                    type: "checkbox",
                    field: "LockAll",
                    title: Helper.getTranslation("WebSMS.UserSettings.LockAll"),
                    "template": (item: CodeLock) => {
                        if (item.LockAll == 1) {
                            return '<span class="k-icon k-i-check k-icon-md"></span>'
                        } else {
                            return '<span class="k-icon k-i-x k-icon-md"></span>'
                        }
                    }
                }
            ]
        };
    }



    private onValueChange = (action, fieldName, dataItems) => {
        if (action != "itemchange" || !(fieldName == "Lock" || fieldName == "LockAll"))
            return;

        const data = this.props.value;
        const index = data.findIndex(f => f.KNR == dataItems[0].KNR)
        data[index][fieldName] = dataItems[0][fieldName]
        this.props.onChange(this.props.field, data, data)
    }

    render() {
        let schema = new Schema();
        schema.Id = "KNR";
        return (
            <div style={{ height: "500px" }}>
                <EditableGrid data={this.props.value}
                    id={"codeRights"}
                    schema={schema}
                    gridOptions={this.gridOptions}
                    editable={!this.props.entity.UserHasRole}
                    onDataChanged={this.onValueChange}
                    validatable={false}
                    showSelectableCheckBox={false}
                    groupable={false}
                    filterable={true}
                    {...this.props}
                />
            </div>
        )
    }
}

interface CodeRightsProps {
    value: CodeLock[];
    onChange: (field, value, dataItem) => void;
    entity: { UserHasRole: boolean };
    field: any;

}

interface CodeLock {
    KNR: number;
    Kennung: string;
    Lock: number;
    LockAll: number;
    //Name: string;
    //Typ: number;
}

